import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ src, size = 16 }) => {
  return (
      <span
          style={{
        display: 'inline-block',
        width: size,
        height: size,
        verticalAlign: 'middle',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        backgroundColor: 'currentColor',
      }}
      />
  );
};

Icon.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number,
};

Icon.defaultProps = {
  size: 16,
};

export default Icon;
